import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  padding: 40px 0px 20px 0px;
`

export const TableCard = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 24px 16px 16px;
  background: #ffffff;
  border-radius: 14px;
  box-shadow: 0 8px 22px rgba(31, 52, 77, 0.08);

  .process-table {
    width: 100%;
    max-width: 100%;
    margin-left: 0;
    margin-right: 0;

    tbody tr {
      height: 64px;
    }

    tbody td {
      padding-top: 8px;
      padding-bottom: 8px;
    }
  }
`

export const SearchSection = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin: 0 0 18px;
`

export const DraftTitle = styled.div`
  flex: 0 0 auto;
  white-space: nowrap;
`

export const DraftTotal = styled.div`
  margin-left: auto;
  color: #5e7183;
  font-family: 'Public Sans', sans-serif;
  font-size: 0.92rem;
  font-weight: 600;
  text-align: right;
  white-space: nowrap;
`

export const SearchField = styled.div`
  flex: 1 1 320px;
  min-width: 280px;
  max-width: 520px;
`

export const SearchActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
`

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  min-height: 260px;
  text-align: center;
`
